import * as React from "react"
import { TooltipSeeker, CardSeeker } from "@ui-seeker/core"
import { Box, Grid, Typography, Skeleton } from "@mui/material"
import { formatNumber, formatPercentage } from "@ui-seeker/utils"

import { 
	columnStructure, mainChartContainer, bgChart, styleShareItem, styleShareLabel, styleShareValue
} from "./styles"
import { useShareOfSearchPercentageGraphData, useShareOfSearchPercentageGraphFilterData } from "./@hooks"
import PercentageChartLegend from "./Legend"


export default function ShareofSearchPercentageChart({ column=false, ...props }) {

	const { color, dataChart, series, isLoading } = useShareOfSearchPercentageGraphData()
	const { handleFilterBrand, handleFilterRemaining } = useShareOfSearchPercentageGraphFilterData()

	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!dataChart?.length) return <></>

    return <CardSeeker title={props.title} sx={{mb: 2, minHeight: props.sx.minHeight + 'px'}}>
		<Grid container item xs={12} sx={column ? mainChartContainer : {}}>
			{dataChart.map((element, idx) => {
				return <Grid key={idx} container spacing={2} sx={ column ? columnStructure : {} }>

					<Grid item xs={!column ? 1 : 12}>
						<Typography>Brands</Typography>
					</Grid>

					<Grid item xs={!column ? 11 : 12}>
						<Box sx={bgChart(column, element.listData?.length)} key={idx}>
							{element.listData.map(({name, percentage, id, tracked}, idx) => {
								const active = true
								const valueFormatted = formatPercentage(percentage)

								const titleTooltip = <Box key={idx} component="span" sx={{textAlign: 'center'}}>
									<Box component="p" sx={{m: 0}} key={idx}>
										<Box component="strong">{name}</Box> {valueFormatted}
									</Box>
									{ id === 'Remaining' && element.remainingData.map((remaining) => <Box component="p" sx={{m: 0}} key={idx}>
											<Box component="strong">{remaining.name + " " + formatPercentage(remaining.percentage, { decimals: 2 })}</Box>
										</Box> 
									)}
								</Box>

								const linkContent = <TooltipSeeker title={titleTooltip}>
									<Box component="span" key={idx} onClick={() => id !== 'Remaining' ? handleFilterBrand(name, id) : handleFilterRemaining(element.remainingData)}>
										{!column && <Box sx={styleShareLabel(column, formatNumber(percentage, {decimals: 0}))}>{name}</Box>}
										{!column && <>
											<Box component="span" sx={{height: '100%', ...styleShareValue(column, percentage, active)}}>{valueFormatted}</Box>
										</>}
									</Box>
								</TooltipSeeker>

								return <Box 
									sx={styleShareItem(column, percentage, color[name], active)}
									key={idx}
								>
									{linkContent}
								</Box>
							})}
						</Box>
					</Grid>

				</Grid>
			})}
		</Grid>

		<Grid container item xs={12}>
			<PercentageChartLegend series={series} color={color} />
		</Grid>
		
	</CardSeeker>
}